import { readShareHash } from "./core/share";
import { mount } from "./embed";

const params = new URLSearchParams(location.search);
const embed = params.get("embed") === "1";

async function boot(): Promise<void> {
  const shared = await readShareHash();
  mount("#app", {
    html: shared ?? "",
    shareBaseUrl: location.href,
    filename: shared ? "Shared.html" : "Untitled.html",
    showChrome: !embed,
    showEditor: true,
  });
}

void boot();
